import { render, staticRenderFns } from "./VDesigningFormRemark.vue?vue&type=template&id=280ccf85&"
import script from "./VDesigningFormRemark.vue?vue&type=script&lang=ts&"
export * from "./VDesigningFormRemark.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports